import { render, staticRenderFns } from "./HeaderSection.vue?vue&type=template&id=179f434b&scoped=true"
import script from "./HeaderSection.vue?vue&type=script&lang=js"
export * from "./HeaderSection.vue?vue&type=script&lang=js"
import style0 from "./HeaderSection.vue?vue&type=style&index=0&id=179f434b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179f434b",
  null
  
)

export default component.exports